import React, { FC } from 'react';
import { FieldStructure } from '../structures/FieldStructure';
import { ScFormGroup, ScFormGroupBottom, ScFormGroupProps } from './styled';

interface FormGroupProps extends ScFormGroupProps {
  title?: string;
  error?: React.ReactNode;
  addons?: React.ReactElement;
  tooltip?: React.ReactElement;
}

export const FormGroup: FC<FormGroupProps> = ({
  children,
  title,
  error,
  tooltip,
  addons,
  ...rest
}) => {
  return (
    <ScFormGroup {...rest}>
      {title && <h3>{title}</h3>}
      {tooltip && <div className="tooltip">{tooltip}</div>}
      <FieldStructure error={error}>{children}</FieldStructure>
      {addons && <div className="addons">{addons}</div>}
    </ScFormGroup>
  );
};

export const FormGroupBottom: FC = ({ children }) => {
  return <ScFormGroupBottom>{children}</ScFormGroupBottom>;
};
